<template>
  <nav class="navbar navbar-expand-md sticky-top shadow-sm">
    <div class="container px-0">
      <RouterLink class="navbar-brand" :to="{ name: 'products' }">{{
        translate('header.home')
      }}</RouterLink>
      <button class="navbar-toggler" type="button" @click="open = !open">
        <i class="fas fa-bars"></i>
      </button>
      <div class="navbar-collapse" :class="{ open }">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="/suppliers">{{
              translate('header.suppliers')
            }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/offers">{{
              translate('offers.title')
            }}</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" href="#">{{ translate('header.vision') }}</a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link" href="#">{{ translate('header.team') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">{{ translate('header.about') }}</a>
          </li>
        </ul>
        <ul class="navbar-nav" v-if="$isLoggedIn">
          <li class="nav-item">
            <a
              class="nav-link"
              href="/profile"
              style="text-transform: uppercase; padding-right: 0px !important"
              >{{ $user.email.split('@')[0] }}</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" @click="logout" style="padding-right: 0px">
              <b-icon icon="power" aria-hidden="true"></b-icon>
            </a>
          </li>
        </ul>

        <ul class="navbar-nav" v-else>
          <li class="nav-item">
            <a class="nav-link" href="#" v-b-modal.user-type-modal>{{
              translate('header.login')
            }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="/register"
              style="padding-right: 0px !important"
              >{{ translate('header.register') }}</a
            >
          </li>
        </ul>
        <b-modal
          id="user-type-modal"
          title="Choose user type"
          centered
          hide-footer
          hide-header
        >
          <div class="text-center">
            <a
              href="/login"
              class="btn btn-primary btn-sm btn-block"
              >I am a Nuyer</a
            >
            <p class="mb-0">or</p>
            <a
              href="/login/supplier"
              class="btn btn-primary btn-sm btn-block"
              >I am a Supplier</a
            >
          </div>
        </b-modal>
      </div>
    </div>
    <LoginRegisterAs />
    <EmailLogin />
  </nav>
</template>

<script>
import api from './../api/axios'
import { SUPPLIER_LOGIN_URL } from '@/constants/endpoints'
export default {
  name: 'Header',
  data() {
    return {
      open: false,
      SUPPLIER_LOGIN_URL
    }
  },
  methods: {
    async logout() {
      try {
        await api.post(`/authentication/login`)
        localStorage.removeItem('_token')
        this.$store.dispatch('deleteUserData')
        location.reload()
      } catch (error) {
        console.log(error)
      }
    },
    openLoginRegAs() {
      localStorage.setItem('login-redirect', 'bookmark-product')
      this.$bvModal.hide('user-type-modal')
      this.$bvModal.show('login-as')
    }
  }
}
</script>

<style scoped lang="scss">
nav {
  background-color: #ff9a22;

  .navbar-brand {
    color: #fff;
  }

  .navbar-toggler {
    border-color: #fff;
    color: #fff;

    &:focus {
      border-color: #fff;
    }
  }

  a {
    color: #fff;
  }
}
.dropdown-toggle::after {
  display: none !important;
}
.caret-off::before {
  display: none;
}
.caret-off::after {
  display: none;
}
.nav-link:hover {
  color: #fff;
  cursor: pointer;
}
@media (max-width: 768px) {
  .navbar-collapse {
    display: block;
    max-height: 0;
    transition: max-height 0.3s;
    overflow: hidden;

    &.open {
      max-height: 200px;
    }
  }
}
</style>
